import {
  LEAK_ICON,
  CONNECTIVITY_ICON,
  BATTERY_ICON,
  CUSTOMER_ICON,
  ANALYSINGMODE_ICON
} from '../constants/deviceStatus/statusIcons'
import {
  LEAK_LABEL,
  CONNECTIVITY_LABEL,
  BATTERY_LABEL,
  APP_LABEL
} from '../constants/deviceStatus/statusLabels'
import {ONBOARDING_EVENTS, ONBOARDING_STATUS} from '../constants/deviceStatus/deviceStatus'
import * as ROLES from '../constants/roles'
import AdminView from '../views/components/AdminView.vue'
import CommsHistoryView from '../views/components/CommsHistoryView'
import ContactNotes from '../views/components/ContactNotes'
import DeviceDataView from '../views/components/DeviceDataView'
import DeviceEventView from '../views/components/DeviceEventView.vue'
import EngineerBookingView from '../views/components/EngineerBookingView.vue'
import LeakFreeView from '../views/components/LeakFreeView.vue'
import ProfileView from '../views/components/ProfileView'
import { EventBus } from '../event-bus.js'
import { DeviceViewEvent } from '../events/deviceViewEvent'
import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { TabNavEvent } from '../events/tabNavEvent'

export default {
  data: function () {
    return {
      deviceData: {},
      deviceParameters: {},
      campaignID: null,
      deviceHasChanges: false,
      ignoreInitialDeviceChange: true,
      currentPage: 1,
      perPage: 10,
      installStatus: '',
      statusReady: false,
      analysingMode: false,
      serialNumber: '',
      highUsageOnly: '',
      headerTankCheckbox: '',
      underfloorHeatingCheckbox: '',
      coldVoidCheckbox: '',
      unknownCheckbox: '',
      fields: {
        type: {
          label: 'Type',
          sortable: false
        },
        created: {
          label: 'Date Opened',
          sortable: false
        },
        closed: {
          label: 'Date Closed',
          sortable: false
        },
        daysActive: {
          label: 'Days active',
          sortable: false
        }
      },
      selected: 'vip-no',
      fieldsNotes: {
        notes: {
          label: 'Notes',
          sortable: false
        }
      }
    }
  },
  components: {
    AdminView,
    CommsHistoryView,
    ContactNotes,
    DeviceDataView,
    DeviceEventView,
    EngineerBookingView,
    LeakFreeView,
    ProfileView
  },
  mounted () {
    this.fetchDeviceData()
    EventBus.$on(DeviceViewEvent.DEVICE_DATA_RECEIVED, () => {
      this.fetchDerivedEvents(this.deviceData.lb_id)
    })
    EventBus.$on('update-leak-status', updateLeakStatus => {
      if (updateLeakStatus) {
        this.fetchDeviceData()
      }
    })
  },
  destroyed () {
    EventBus.$off(DeviceViewEvent.DEVICE_DATA_RECEIVED)
  },
  filters: {
    leakIcon (data) { return LEAK_ICON[data] },
    leakLabel (data) { return LEAK_LABEL[data] },
    connectivityIcon (data) { return CONNECTIVITY_ICON[data] },
    connectivityLabel (data) { return CONNECTIVITY_LABEL[data] },
    batteryIcon (data) { return BATTERY_ICON[data] },
    analysingModeIcon (data) { return ANALYSINGMODE_ICON[data] },
    batteryLabel (data) { return BATTERY_LABEL[data] },
    customerIcon (data) { return CUSTOMER_ICON[data] },
    appLabel (data) { return APP_LABEL[data] },
    obtain (data, params) {
      if (data !== '') {
        return data
      } else {
        let message = 'Obtain ' + params.property
        if (params.roleID === ROLES.MAINTENANCE || params.roleID === ROLES.INSURANCE) {
          message = 'Not available'
        }
        return message
      }
    }
  },
  methods: {
    reRenderView () {
      if (this.updateLeakStatus) {
        this.fetchDeviceData()
      }
    },
    handleError (error) {
      switch (error.error) {
        case 205:
          this.campaignID = ''
          break

        case 59:
          this.campaignID = ''
          break

        case 532:
          this.campaignID = ''
          break

        case 305:
          this.campaignID = ''
          break

        case 507:
          this.campaignID = ''
          break

        case 209:
          this.campaignID = ''
          break

        default:
          EventBus.$emit(StatusBarEvent.ERROR, error.message)
          break
      }
    },
    fetchCampaignID () {
      this.$store.dispatch(APIEvent.FETCH_CAMPAIGN_ID, {serial_number: this.serialNumber})
        .then((res) => {
          if (res.data.campaign_id === 'ERROR' || res.data.campaign_id === 'null') {
            this.campaignID = ''
          } else { this.campaignID = res.data.campaign_id }
        })
        .catch(this.handleError)
    },
    fetchDeviceData () {
      this.$store.dispatch(APIEvent.FETCH_DEVICE, this.$route.params.deviceID)
        .then((response) => {
          this.deviceData = response.data.Device
          this.deviceParameters = response.data.deviceParameters
          this.serialNumber = response.data.Device.serialNumber
          this.fetchCampaignID()
          this.serialNumber = response.data.Device.serialNumber
          for (let j = 0; j < response.data.install_environment.length; j++) {
            if (response.data.install_environment[j] === 'High Usage Only') {
              this.analysingMode = 'High Usage Only'
            }
          }
          for (var key in this.deviceData) {
            if (this.deviceData.hasOwnProperty(key)) {
              if (key === 'address_2' || key === 'address_3' || key === 'home_tel_number') {
                if (this.deviceData[key] === 'null') {
                  this.deviceData[key] = ''
                }
              }
            }
          }
          EventBus.$emit(DeviceViewEvent.DEVICE_DATA_RECEIVED, this.deviceData)
        })
        .catch(this.handleError)
    },
    fetchDerivedEvents (id) {
      this.determineOnboardStatus([]);
      // let data = {LbDevice_ID: id}
      // this.$store.dispatch(APIEvent.FETCH_DERIVED_EVENTS, data)
      //   .then((response) => {
      //     this.determineOnboardStatus(response.data.list.records)
      //   })
      //   .catch(this.handleError)
    },
    determineOnboardStatus (eventList) {
      let statusMaps = [
        {
          [ONBOARDING_EVENTS.LEAK_FALSE]: true,
          status: ONBOARDING_STATUS.COMPLETE
        },
        {
          [ONBOARDING_EVENTS.LEAK_TRUE]: true,
          status: ONBOARDING_STATUS.COMPLETE
        },
        {
          [ONBOARDING_EVENTS.LEAK_TRUE]: true,
          [ONBOARDING_EVENTS.LEAK_FALSE]: true,
          status: ONBOARDING_STATUS.COMPLETE
        },
        {
          [ONBOARDING_EVENTS.ON_PIPE]: true,
          [ONBOARDING_EVENTS.LEAK_TRUE]: false,
          [ONBOARDING_EVENTS.LEAK_FALSE]: false,
          status: ONBOARDING_STATUS.AWAITING_LEAK
        },
        {
          [ONBOARDING_EVENTS.WAITING_ON_PIPE]: true,
          [ONBOARDING_EVENTS.ON_PIPE]: false,
          [ONBOARDING_EVENTS.LEAK_TRUE]: false,
          [ONBOARDING_EVENTS.LEAK_FALSE]: false,
          status: ONBOARDING_STATUS.AWAITING_TAP
        },
        {
          [ONBOARDING_EVENTS.REGISTERED]: true,
          [ONBOARDING_EVENTS.WAITING_ON_PIPE]: false,
          [ONBOARDING_EVENTS.ON_PIPE]: false,
          [ONBOARDING_EVENTS.LEAK_TRUE]: false,
          [ONBOARDING_EVENTS.LEAK_FALSE]: false,
          status: ONBOARDING_STATUS.PAIRED
        }
      ]
      let currentStatus = {
        [ONBOARDING_EVENTS.REGISTERED]: false,
        [ONBOARDING_EVENTS.WAITING_ON_PIPE]: false,
        [ONBOARDING_EVENTS.ON_PIPE]: false,
        [ONBOARDING_EVENTS.LEAK_TRUE]: false,
        [ONBOARDING_EVENTS.LEAK_FALSE]: false
      }

      for (var i = 0; i < eventList.length; i++) {
        var type = eventList[i].type
        if (typeof currentStatus[type] !== 'undefined') {
          currentStatus[type] = true
        }
      }
      for (var j = 0; j < statusMaps.length; j++) {
        if (this.statusesMatch(statusMaps[j], currentStatus)) {
          this.installStatus = statusMaps[j].status
          break
        } else {
          this.installStatus = statusMaps[j].status
        }
      }
      this.statusReady = true
    },
    statusesMatch (obj1, obj2) {
      for (var prop in obj1) {
        if (obj1.hasOwnProperty(prop) && typeof obj1[prop] === 'boolean') {
          if (obj2.hasOwnProperty(prop) && typeof obj2[prop] === 'boolean') {
            if (obj1[prop] === obj2[prop]) {
              continue
            } else {
              return false
            }
          }
        }
      }
      return true
    },
    tabSwitchHandler (tabIndex) {
      // order breaks when not all items are shown
      // TODO: create tab index map for each role?
      if ((this.$store.getters.roleID === ROLES.MAINTENANCE || this.$store.getters.roleID === ROLES.INSURANCE ) && tabIndex === 1) {
        EventBus.$emit(TabNavEvent.COMMS_HISTORY)
      }
      switch (tabIndex) {
        case 1:
          EventBus.$emit(TabNavEvent.CONTACT_NOTES)
          break
        case 2:
          EventBus.$emit(TabNavEvent.DEVICE_EVENTS)
          break
        case 3:
          EventBus.$emit(TabNavEvent.DEVICE_DATA)
          break
        case 4:
          EventBus.$emit(TabNavEvent.COMMS_HISTORY)
          break
        case 5:
          EventBus.$emit(TabNavEvent.ENG_BOOKING)
          break
        case 6:
          EventBus.$emit(TabNavEvent.ADMIN)
          break
        case 7:
          EventBus.$emit(TabNavEvent.LEAK_FREE)
          break
      }
    }
  }
}
